"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateTapeBuilderOperationDefinitions = void 0;
const consts_1 = require("../consts");
// base field names must be LTE 118 characters
// for ingestion into datalake, due to 128 char limit (there are other chars due normalized property nesting)
const baseFieldNameMaximumLength = 118;
const generatedArtifactTypes = {
    generatedCovenantLoanTape: 'generatedCovenantLoanTape',
    generatedCashBalanceFeed: 'generatedCashBalanceFeed',
    generatedLoanTape: 'generatedLoanTape',
    generatedRepaymentTape: 'generatedRepaymentTape',
    generatedSupplementalTape: 'generatedSupplementalTape',
    generatedFinancialData: 'generatedFinancialData',
};
const checkBaseFieldNameLengths = ({ tapeDefinition, type, }) => {
    if (Object.keys(generatedArtifactTypes).includes(type)) {
        const longBaseFieldNames = [];
        tapeDefinition.baseFields.forEach(({ field }) => {
            if (field.length > baseFieldNameMaximumLength) {
                longBaseFieldNames.push(field);
            }
        });
        if (longBaseFieldNames.length) {
            return `fields [${longBaseFieldNames.join('|')}] exceed maximum length of ${baseFieldNameMaximumLength}. Please use edit step to rename baseFields.`;
        }
    }
    return null;
};
const validateTapeBuilderOperationDefinitions = ({ dbGraph, tapeBuilder, }) => {
    const derivedTapes = dbGraph.dataTapes.filter((tape) => (0, consts_1.isDerivedTapeType)(tape.type));
    const errors = [];
    // walk all derived tapes, generate tape definitions and collect errors if any
    derivedTapes.forEach((tape) => {
        const tapeDefinitionResult = tapeBuilder.generateTapeDefinition(tape.id);
        if (!tapeDefinitionResult.isValid) {
            errors.push(...tapeDefinitionResult.errors);
        }
        // post tape generation check to ensure baseFields do not exceed maximum datalake column length
        if (tapeDefinitionResult.isValid && tapeDefinitionResult.data) {
            const error = checkBaseFieldNameLengths({
                tapeDefinition: tapeDefinitionResult.data,
                type: tape.type,
            });
            if (error) {
                errors.push(error);
            }
        }
    });
    return errors;
};
exports.validateTapeBuilderOperationDefinitions = validateTapeBuilderOperationDefinitions;
//# sourceMappingURL=validateOperationDefinitions.js.map